import { render, staticRenderFns } from "./base-info-from.vue?vue&type=template&id=a0517c0e"
import script from "./base-info-from.vue?vue&type=script&lang=js"
export * from "./base-info-from.vue?vue&type=script&lang=js"
import style0 from "./base-info-from.vue?vue&type=style&index=0&id=a0517c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports